import { useEffect } from "react";
import { useSkills } from "../../../hooks/useSkills";
import SkillsList from "../../skills-list/SkillsList";

type SkillsTabProps = {
  finishedSkills: string[];
  handleUpdateSkills?: (finishedSkills: string[]) => Promise<boolean>;
  isEditable: boolean;
  colorPrimary?: boolean;
};
export default function SkillsTab(props: SkillsTabProps) {
  const { finishedSkills, handleUpdateSkills, isEditable, colorPrimary } =
    props;
  const { skills, onSkillClick, setFinishedSkills } = useSkills(
    finishedSkills,
    handleUpdateSkills
  );
  useEffect(() => {
    setFinishedSkills(finishedSkills);
  }, [finishedSkills]);
  return (
    <div className="w-full h-full flex flex-col overflow-y-auto quraan-viewer">
      <div className="h-0">
        <SkillsList
          skills={skills || []}
          onSkillClick={onSkillClick}
          isEditable={isEditable}
          colorPrimary={colorPrimary}
        />
      </div>
    </div>
  );
}
